<template>
	<scope v-bind="[item, {variantsOpen}]">
		<div class="product" slot-scope="{title, variant, multi, price, rules, sku, url, thumb, cartProduct, itemsCount, toggleVariants}">
			<div class="cells">
				<div class="cell-image">
					<div class="image" :class="{active: cartProduct}">
						<img :src="thumb"/>
					</div>
				</div>
				<div class="cell-info">
					<div class="title">{{title}}</div>
					<a class="link" :href="url" target="_blank">Se produktinfo</a>
					<div class="note" v-if="rules.increment_by > 1">
						*Sælges i kolli af {{rules.increment_by}}stk.
					</div>
				</div>
				<div class="cell-sku">
					<template v-if="!multi">{{sku}}</template>
					<template v-else>[Flere]</template>
				</div>
				<div class="cell-price">
					<template v-if="!multi">{{price}}</template>
				</div>
				<div class="cell-counter">
					<counterFull v-if="!multi" v-bind="{props: {productId: variant.product_id, variantId: variant.id, rules: variant.rules}}"/>

					<a class="button" :class="{items: itemsCount}" @click="toggleVariants" v-else>
						<div class="count" v-if="itemsCount" v-text="itemsCount"/>
						<div class="icon" :class="{active: variantsOpen}" v-html="require('@/assets/icons/chevron-down-solid.svg')"/>
					</a>
				</div>
			</div>
		</div>
	</scope>
</template>

<script>
import counterFull from "@/components/counter/full.vue";
import scope from "../../../shared/group/item/product";

export default {
	components: {counterFull, scope},
	props: {
		item: {type: Object, required: true},
		variantsOpen: {type: Boolean, required: true}
	}
};
</script>

<style lang="scss" scoped>
.product {
	z-index: 1;
	position: relative;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	background-color: $white1;
	min-height: em(112);
	display: flex;
	align-items: center;

	.cells {
		.cell {
			&-image {
				.image {
					padding: 0.5em;
					$s: 80px;
					width: $s;
					height: $s;
					border: 1px solid #E1E5E7;

					&.active {
						border-color: $black2;
					}

					img {
						display: block;
					}
				}
			}
			&-info {
				.title {
					font-size: 15px;
					font-weight: 500;
				}
				.link {
					display: inline-block;
					color: #007ACE;
					font-size: 13px;
					margin: 6px 0;
				}
				.note {
					font-size: 12px;
				}
			}
			&-counter {
				.button {
					user-select: none;
					display: block;
					border: 1px solid #C4CDD5;
					display: inline-flex;
					align-items: center;

					border-radius: 4px;
					padding: 0 12px;
					height: 36px;

					&.items {
						background-color: $black2;
						border-color: $black2;
						color: $white1;

						.icon /deep/ svg path {
							fill: $white1;
						}
					}

					.count {
						margin-right: 0.7em;
						font-size: 14px;
					}

					.icon {
						&.active {
							transform: rotate(180deg) translateY(-1px);
						}

						/deep/ svg {
							$s: 10px;
							width: $s;
							height: $s;
							path {
								fill: #798087;
							}
						}
					}
				}
			}
		}
	}
}
</style>
